"use strict"
exports.__esModule = true;
exports.VoicemailIconConfig = {
  name: 'VoicemailIcon',
  height: 512,
  width: 640,
  svgPath: 'M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z',
  yOffset: 0,
  xOffset: 0,
};
exports.VoicemailIcon = require('../createIcon').createIcon(exports.VoicemailIconConfig);
exports["default"] = exports.VoicemailIcon;